/*
 *人员选择器 搜索组件 输入框
 */
import { Input } from 'antd';
import React from 'react';
import searchIcon from '../../images/app_ic_search.png';
export default function SearchInput(_a) {
    var searchValue = _a.searchValue, onSearchValueChange = _a.onSearchValueChange, placeholder = _a.placeholder, onSetIsChange = _a.onSetIsChange, inputRef = _a.inputRef;
    // const inputRef: any = useRef({});
    return (React.createElement("div", { className: "focus-search-global-input-container" },
        React.createElement(Input, { ref: inputRef, allowClear: true, prefix: 
            // <span >
            React.createElement("img", { src: searchIcon, className: "focus-search-global-input-prefix", alt: "" }), placeholder: placeholder, className: "focus-search-global-input", value: searchValue, onChange: function (e) {
                onSearchValueChange(e.target.value);
            }, onCompositionStart: function (e) {
                if (onSetIsChange) {
                    onSetIsChange(true);
                }
            }, onCompositionEnd: function (e) {
                if (onSetIsChange) {
                    onSearchValueChange(e.target.value);
                    onSetIsChange(false);
                }
            } })));
}
//# sourceMappingURL=Input.js.map